import React from 'react';
import styled from 'styled-components';

const Aermod3DContainer = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

const Aermod3DFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: block;
`;

const Aermod3D: React.FC = () => {
  const aermod3DUrl = process.env.REACT_APP_AERMOD_3D_URL;

  if (!aermod3DUrl) {
    return null;
  }

  return (
    <Aermod3DContainer>
      <Aermod3DFrame
        src={aermod3DUrl}
        title="Enviro Aermod3D"
        allow="fullscreen; clipboard-read; clipboard-write; geolocation"
        allowFullScreen
      />
    </Aermod3DContainer>
  );
};

export default Aermod3D;
